// @ts-nocheck
import clsx from "clsx";
import FormInput from "./FormInput";
import FormTextarea from "./FormTextarea";
import { FormField } from "../data/models";
import React from "react";
import DropdownField from "./DropdownField";

export interface FormSectionProps {
  title: string;
  subtitle?: string;
  fields?: FormField[];
  columns?: 1 | 2;
  data?: Record<string, any>;
  name?: string;
  placeholder?: string;
  onChange?: (values: Record<string, any>) => void;
  setErrors: React.Dispatch<React.SetStateAction<string[]>>;
  errors: string[];
  children?: React.ReactNode;
  inputRefs: React.MutableRefObject<Record<string, HTMLInputElement | null>>;
  childrenOrder?: string;
}

export function FormSection(props: FormSectionProps) {
  const {
    title,
    subtitle,
    fields,
    columns = 1,
    data = {},
    onChange,
    setErrors,
    errors,
    children,
    inputRefs,
    childrenOrder = "back",
  } = props;

  const handleInputChange = (name: string, value: string | string[]) => {
    const updatedData = { ...data, [name]: value }; // Može prihvatiti string ili string[]
    if (value) {
      setErrors((prevErrors) => prevErrors.filter((error) => error !== name));
    }
    if (onChange) {
      onChange(updatedData);
    }
  };

  const layout = {
    1: "",
    2: "sm:grid-cols-2",
  };

  return (
    <div className="flex flex-col gap-4">
      <h3 className="text-[17px] font-bold tracking-tightest uppercase">
        {title}
      </h3>
      {subtitle && <h4 className="text-sm text-opacity-90">{subtitle}</h4>}
      {childrenOrder === "front" && children}
      <div
        className={clsx("grid grid-cols-1 gap-3", layout && layout[columns])}
      >
        {fields?.map((field, index) => (
          <React.Fragment key={index}>
            {field.type !== "dropdown" && field.type !== "textarea" ? (
              <FormInput
                key={index}
                name={field.name}
                placeholder={field.placeholder}
                required={field.required}
                type={field.type}
                value={data[field.name] || ""}
                onChange={(e) => handleInputChange(field.name, e.target.value)}
                errors={errors}
                readOnly={field.readOnly}
                inputRefs={inputRefs}
              />
            ) : field.type === "dropdown" ? (
              <div key={index} className="flex flex-col gap-2">
                <label htmlFor={field.name} className="text-sm font-medium">
                  {field.name}
                  {field.required && (
                    <span className="pl-1 text-[13px] text-warning-red">*</span>
                  )}
                </label>
                <DropdownField
                  field={field}
                  value={data[field.name]} // ID iz state-a
                  onChange={(nextId) => handleInputChange(field.name, nextId)} // u state ide ID
                />
              </div>
            ) : field.type === "textarea" ? (
              <FormTextarea
                key={index}
                name={field.name}
                placeholder={field.placeholder}
                required={field.required}
                value={data[field.name] || ""}
                onChange={(e) => handleInputChange(field.name, e.target.value)}
                errors={errors}
              />
            ) : (
              <></>
            )}
          </React.Fragment>
        ))}
      </div>
      {childrenOrder === "back" && children}
    </div>
  );
}

export default FormSection;
